import { API_HOST_NAME } from "../../constants.js";
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js";

const useProjectFilesResources = (teamId, projectId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/files`;

  const additionalActions = [
    { name: 'edit', path: 'edit', method: 'GET', member: true }
  ];

  return useAuthenticatedResources(url, { mode: 'form' }, additionalActions);
}

export default useProjectFilesResources;
